<!--
 * @Author: LiZhiWei
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-02-24 15:48:17
 * @Description: 
-->
<template>
  <section-hero />
  <lazy-section-solution />
  <lazy-section-ability />
  <lazy-section-cases />
  <lazy-section-partnership />
  <lazy-section-history />
  <lazy-section-cta />
</template>

<script setup lang="ts">
  useSeoMeta({
    title: '绘家科技 - 智慧社区整体解决方案',
    description:
      '绘家科技致力于为物业管理公司提供数字化转型解决方案，包括绘管家智慧物业云平台、绘服务业主端小程序等，提升服务品质与业主满意度。',
    keywords: '智慧物业,物业管理系统,社区数字化,绘管家,绘家科技',
    ogTitle: '绘家科技 - 智慧社区整体解决方案',
    ogDescription:
      '绘家科技致力于为物业管理公司提供数字化转型解决方案，包括绘管家智慧物业云平台、绘服务业主端小程序等，提升服务品质与业主满意度。',
    ogImage: '/logo.png',
  })
</script>
